export class Carrier {
  CarrierName: string = "";
  CarrierImageUri: String = "";
  nqsCarrierId: string = "";
  networks: string = "";
  CarrierImageUriForExcel: String = "";
}

export class CarrierLogoRequest {
  CarrierIds: number[] = [];
  OrionCarrierIds: string[] = [];
}
